import type { FirstPaymentDefinitionsDTO } from '@/shared/model';
import { toPrepaymentPercent } from './toPrepaymentPercent';
import type { PrepaymentSource, PrepaymentSummary } from '../model/types';

/** Доля приходит дробью от единицы: 0.5 — это 50%, а единица — оплата целиком. */
const FULL_PAYMENT = 1;

/**
 * Что вообще считается предоплатой: единица — это оплата целиком, а ноль и отрицательные доли
 * приходят мусором. Единая проверка на весь слайс — по ней же собираются варианты для шторки.
 */
export function isPrepaymentDefinition(definition: FirstPaymentDefinitionsDTO): boolean {
  const { firstPaymentPart } = definition;

  return Number.isFinite(firstPaymentPart) && firstPaymentPart > 0 && firstPaymentPart < FULL_PAYMENT;
}

export function getPrepaymentSummary(product: PrepaymentSource | null): PrepaymentSummary | null {
  if (!product || !Number.isFinite(product.price) || product.price <= 0) return null;

  let summary: PrepaymentSummary | null = null;

  for (const definition of product.firstPaymentDefinitions ?? []) {
    if (!isPrepaymentDefinition(definition)) continue;

    const amount = Math.round(product.price * definition.firstPaymentPart);

    if (summary === null || amount < summary.amount) {
      summary = { amount, percent: toPrepaymentPercent(definition.firstPaymentPart) };
    }
  }

  return summary;
}
